﻿import { FC } from "react";
import { Center, Text } from "@chakra-ui/react";

export const ErrorFallback: FC = () => (
    <Center height={"100%"}>
        <Text>Something went wrong.</Text>
    </Center>
);
